import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { CreateIndustryAutomationTemplate } from '../../containers/templates/CreateIndustryAutomationTemplate';

export function AdminIndustryNewAutomationPage() {
	return (
		<AdminDashboardPageLayout>
			<CreateIndustryAutomationTemplate />
		</AdminDashboardPageLayout>
	);
}
